import { EventsFindOneResponseBodyEventItemDto } from '../api/events';
import { MainCategoryItem, PRODUCT_STATUS_V2 } from '../product';
import { DateRageType } from '../common/date';

export class EventProductItemV2 {
  id: number;
  imageUrl: string;
  name: string;
  status: PRODUCT_STATUS_V2;
  originPrice: number;
  salesPrice: number;
  discountPrice: number;
  discountRate: number | null;
  discountPeriod: DateRageType;
  brandId: number;
  brandName: string;
  createDate: string;
  mainCategoryList: MainCategoryItem[];
  constructor(item: EventsFindOneResponseBodyEventItemDto) {
    this.id = item.product.id;
    this.name = item.product.name;
    this.imageUrl = item.productAttachments[0]?.url || '';
    this.status = item.product.status;
    this.originPrice = item.product.originPrice;
    this.salesPrice = item.product.salesPrice;
    this.discountPrice = item.product.discountPrice || 0;
    this.discountRate = item.product.discountRate;
    this.discountPeriod = {
      startDate: item.product.discountStartDate || null,
      endDate: item.product.discountEndDate || null,
    };
    this.brandId = item.store.id;
    this.brandName = item.store.name;
    this.createDate = item.product.createDate;
    this.mainCategoryList = item.productCategories;
  }
}
